<template>
  <Modal
    header="View Business"
    class="calico-usage-view-profile"
  >
    <template #content>
      <div class="section">
        <CalicoUsageLimitBox
          :limit="limit"
          :remaining="remaining"
          :viewed="viewed"
        />
        <div class="copy">
          <template v-if="isLimitReached">
            <h3 class="heading--xsmall">
              You have no remaining BetaScores.
            </h3>
            <div class="body--medium">
              Contact us to upgrade your subscription and usage limit.
              Usage resets every billing cycle.
            </div>
          </template>
          <template v-else>
            <h3 class="heading--xsmall">
              Are you sure you want to view this business?
            </h3>
            <div class="body--medium">
              Viewing this business counts towards your usage,
              and you will be able to view this business for {{ daysValid }} days.
            </div>
          </template>
          <p
            v-if="errorMessage"
            class="body--small usage-error"
          >
            {{ errorMessage }}
          </p>
        </div>
      </div>
    </template>

    <template #footer>
      <button
        v-if="isLimitReached"
        class="button-utility"
        @click="upgrade"
      >
        Upgrade Subscription
      </button>
      <template v-else>
        <button
          class="button-primary"
          :disabled="confirming"
          @click="$emit('confirm')"
        >
          <span v-if="confirming">Confirming…</span>
          <span v-else>Yes, Confirm</span>
        </button>
        <button
          class="button-secondary"
          @click="$emit('close')"
        >
          Go Back
        </button>
      </template>
    </template>
  </Modal>
</template>

<script>
import { computed } from "vue";
import Modal from "@/components/template/modal/index.vue";
import CalicoUsageLimitBox from "@/components/calico/usageLimitBox/index.vue";
import { upgrade } from "@/composables/auth/useUsage";


export default {
  name: "CalicoUsageViewProfileConfirmation",
  components: {
    Modal,
    CalicoUsageLimitBox
  },
  props: {
    limit: {
      type: [Number, String],
      required: true
    },
    remaining: {
      type: [Number, String],
      required: true
    },
    viewed: {
      type: [Number, String],
      default: 0
    },
    reason: {
      type: String,
      default: ""
    },
    daysValid: {
      type: Number,
      default: 30
    },
    confirming: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ""
    }
  },
  setup(props) {
    const isLimitReached = computed(() => {
      const r = Number(props.remaining);
      return Number.isFinite(r) ? r <= 0 : false;
    });
    
    return { 
      isLimitReached, 
      upgrade 
    };
  }
};
</script>

<style lang="scss">
.calico-usage-view-profile {
  .content {
    @include inset-space($space-large);
    @include stack-space($space-large);
    background: $color-background-primary;
    color: $color-text-primary;
  }
  .section {
    @include stack-space($space-large);
  }
  .copy {
    text-align: center;
    @include stack-space($space-small);
  }
  .usage-error {
    color: $color-text-error;
    text-align: center;
  }
}
</style>
